// src/components/Sidebar.js
import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { ExpandLess, ExpandMore, GridViewOutlined } from "@mui/icons-material";
import { Box, Toolbar } from "@mui/material";
import { Images } from "../assets/images";
import colors from "../styles/colors";
import { Icons } from "../assets/Svgs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearSession } from "../utils/session";

const drawerWidth = 240;

const Sidebar = ({ open, drawerWidth }) => {
  const [openTab, setOpenTab] = React.useState(false);
  const [focusedTab, setFocusedTab] = useState(0);
  const lang = useSelector((state) => state.authReducer.lang);
  const words = useSelector((state) => state.authReducer.words);
  const navigate = useNavigate();

  const tabs = [
    {
      navigateTo: "/dashboard/home",
      name: words["Dashboard"],
      icon: Icons.dashboardSIcon,
    },
    // { navigateTo: "", name: words["Users"], icon: Icons.staffSIcon },
    { navigateTo: "/dashboard/categories", name: words["Categories"], icon: Icons.categoriesSIcon },
    { navigateTo: "/dashboard/customers", name: words["Customer"], icon: Icons.customerSIcon, },
    { navigateTo: "/dashboard/ads", name: words["Ads"], icon: Icons.accountsSIcon },
    { navigateTo: "/dashboard/bookings", name: words["List Bookings"], icon: Icons.reportsSIcon },
    { navigateTo: "/dashboard/notifications", name: words["Notifications"], icon: Icons.notficationsSIcon },
    { navigateTo: "/dashboard/settings", name: words["Settings"], icon: Icons.settingsSIcon },
    
    { navigateTo: "logout", name: words["Logout"], icon: Icons.logoutIcon },
  ];

  const handleTabClick = (index) => {
    setFocusedTab(index);
  };

  return (
    <Drawer
      // dir={lang == 'en' ? 'ltr' : 'rtl'}
      variant={open ? "permanent" : "temporary"} // Sidebar type
      open={open}
      anchor={lang == "en" ? "left" : "right"}
      sx={{
        width: open ? drawerWidth : 0,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          transition: "width 0.7s ease",
          backgroundColor: colors.sidebar,
        },
      }}
    >
      <div
        style={{
          display: "block",
          margin: "0 auto",
          marginTop: 20,
          maxWidth: "100%",
          height: "auto",
        }}
      >
        <Icons.logoIcon width={182} height={100} />
      </div>
      {/* <img
                src={Images.logo}
                alt="Logo"
                style={{
                    display: 'block',
                    margin: '0 auto',
                    marginTop: 20,
                    maxWidth: '100%',
                    height: 'auto',
                }}
            /> */}
      {/* Optional toolbar to push the content down */}
      {/* <Toolbar /> */}
      <div style={{ marginTop: 20, cursor: "pointer" }} />

      <List>
        {tabs.map((text, index) => {
          const Icon = text.icon;
          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: 1,
                cursor: "pointer",
              }}
            >
              <ListItem
                button
                key={index}
                onClick={() => {
                  if (text.navigateTo == 'logout') {
                    clearSession();
                    window.location.reload();
                    return;
                  }
                  navigate(text.navigateTo);
                  handleTabClick(index);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  borderRadius: "30px",
                  height: 50,
                  // padding: '10px ',
                  justifyContent: "flex-start",
                  width: "90%", // Adjusting width to create a full tab effect
                  backgroundColor:
                    focusedTab === index ? colors.focusBg : "transparent",
                  color: focusedTab === index ? colors.white : colors.black,
                  // '&:hover': {
                  //     backgroundColor: colors.focusBg,
                  //     color: colors.focusText,
                  // },
                }}
              >
                {/* <RenderIcon focused={focusedTab === index} /> */}
                {/* <div style={{width:40}}> */}
                <Icon
                  color={focusedTab == index ? colors.white : colors.black}
                />
                {/* </div> */}
                <ListItemText
                  primary={text.name}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "PMe",
                      textAlign: lang == "en" ? "left" : "right",
                      marginLeft: lang == "en" ? "10px" : 0,
                      marginRight: lang == "ar" ? "10px" : 0,
                      fontSize: 15,
                    },
                  }}
                />
              </ListItem>
            </Box>
          );
        })}
      </List>
      {/* <List>
                <ListItem button onClick={handleClick}>
                    <ListItemText primary="Main Tab 1" />
                    {openTab ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openTab} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button sx={{ pl: 4 }}>
                            <ListItemText primary="Subtab 1-1" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }}>
                            <ListItemText primary="Subtab 1-2" />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button>
                    <ListItemText primary="Main Tab 2" />
                </ListItem>
            </List> */}
    </Drawer>
  );
};

export default Sidebar;
